import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import * as api from './api';

import { AbonentStateData } from './types';

const initialState: AbonentStateData = {
	data: {
		data: {
			a_home_number: '',
			abonent: {
				a_home_number: '',
				account_id: '',
				activate_date: '',
				agent_scheme: '',
				alert_crm: '',
				alert_hdsk: '',
				alert_last_date: '',
				atol_config_id: '',
				auto_account: '',
				auto_account_interval: '',
				autopay_pay_log_id: '',
				billing_settings_id: '',
				category_id: '',
				code1c: '',
				company: '',
				contract_number: '',
				contract_prefix: '',
				create_date: '',
				create_date_system: '',
				currency_id: '',
				deleted: '',
				disabled_date: '',
				disabled_date_end: '',
				discount: '',
				email: '',
				enabled: '',
				home_entrance: '',
				home_id: '',
				id: '',
				imported_id: '',
				ip_pull_id: '',
				is_folder: '',
				level: '',
				lft: '',
				loyalty_id: '',
				main: '',
				master_id: '',
				migration_info: '',
				modified: '',
				multi_act: '',
				name: '',
				nds: '',
				need_recalc: '',
				need_refresh_cache: '',
				next_auto_acount: '',
				operator_id: '',
				own_disabled_end: '',
				own_disabled_start: '',
				parent_id: '',
				penalties: '',
				personal_act: '',
				prebilled: '',
				promise_countpermonth: '',
				promise_date_end: '',
				promise_pay: '',
				push_token: '',
				recursive_childs_count: '',
				recursive_deleted_childs_count: '',
				rewrite_inherit: '',
				rght: '',
				security_alert: '',
				send_act: '',
				sms: '',
				sync1c: '',
				tarif_id: '',
				tarif_next_date: '',
				tarif_next_date_prev: '',
				tarif_next_id: '',
				tarif_notified: '',
				tree_id: '',
				usluga_range_type_id: '',
				___account_cache: '',
				___operator_cache: '',
				___tarif_cache: '',
				_account_cache: {
					alert_last_date_limit: '',
					balance: '',
					balance_adjust: '',
					balance_buh: '',
					bonus_score: '',
					credit: '',
					credit_add: '',
					credit_adjust: '',
					credit_adjust_add: '',
					currency: {},
					debit: '',
					do_notify_changes: '',
					hack_limit: '',
					id: '',
					limit: '',
					limit_warning: '',
					ostatok: '',
					ostatok_add: '',
					overlimit_sum: '',
					pk: '',
					unlimited: '',
					unlimited_date: '',
					__currency: '',
					__self: '',
				},
				_changed_data: [],
				_operator_cache: {
					a_home_number: '',
					abon_pay_for_today: '',
					account: {},
					activate_date: '',
					agent_scheme: '',
					alert_crm: '',
					alert_hdsk: '',
					alert_last_date: '',
					allow_internet: '',
					atol_config: '',
					auto_account: '',
					auto_account_interval: '',
					autopay_pay_log: '',
					billing_settings: {},
					category: {},
					child_folders_count: '',
					childs_count: '',
					code1c: '',
					company: '',
					contract_number: '',
					contract_prefix: '',
					create_date: '',
					create_date_system: '',
					currency: {},
					deleted: '',
					disabled_date: '',
					disabled_date_end: '',
					discount: '',
					do_notify_changes: '',
					email: '',
					enabled: '',
					generated_contract_number: '',
					home: '',
					home_entrance: '',
					id: '',
					imported_id: '',
					ip_pull: '',
					is_folder: '',
					level: '',
					lft: '',
					loyalty: '',
					main: '',
					master: '',
					migration_info: '',
					minimal_pay_sum: '',
					modified: '',
					multi_act: '',
					name: '',
					nds: '',
					need_recalc: '',
					need_refresh_cache: '',
					next_auto_acount: '',
					object_status: {},
					operator: {},
					own_disabled_end: '',
					own_disabled_start: '',
					parent: {},
					penalties: '',
					personal_act: '',
					pk: '',
					post_pay_credit: '',
					prebilled: '',
					promise_countpermonth: '',
					promise_date_end: '',
					promise_pay: '',
					push_token: '',
					real_limit: '',
					recomend_pay_sum: '',
					recomend_pay_sum_post: '',
					recursive_childs_count: '',
					recursive_deleted_childs_count: '',
					rewrite_inherit: '',
					rght: '',
					security_alert: '',
					send_act: '',
					sms: '',
					sync1c: '',
					tarif: {},
					tarif_next: '',
					tarif_next_date: '',
					tarif_next_date_prev: '',
					tarif_notified: '',
					tree_id: '',
					usluga_range_type: '',
					__account: '',
					__billing_settings: '',
					__category: '',
					__currency: '',
					__object_status: '',
					__operator: '',
					__parent: '',
					__self: '',
					__tarif: '',
				},
				_prefetched_objects_cache: { abonent_id_abonentsblock: [], abonent_id_attributevalues: [] },
				_state: '',
				_tarif_cache: {
					act_shift: '',
					agent_show_mbyte: '',
					allow_change_activated: '',
					allow_change_from: '',
					allow_change_negbal: '',
					allow_change_to: '',
					allow_limit: '',
					allways_apply: '',
					archived: '',
					change_cost: '',
					change_group: '',
					change_minday: '',
					change_only_end_day: '',
					change_only_end_period: '',
					change_renew_ip: '',
					default_nat: '',
					do_notify_changes: '',
					free_own_block_period: '',
					id: '',
					iface_id: '',
					imported_id: '',
					inactive_days: '',
					inactive_group: '',
					inactive_tarif: '',
					is_used: '',
					limit: '',
					limit_block_sum: '',
					migration_info: '',
					name: '',
					nat_dyn_end: '',
					nat_dyn_start: '',
					operator: '',
					own_disabled_cost: '',
					own_disabled_countpermounth: '',
					own_disabled_maxdays: '',
					own_disabled_mindays: '',
					own_disabled_usluga: '',
					pk: '',
					plan_comment: '',
					promise_countpermonth: '',
					promise_days: '',
					promise_maxday: '',
					promise_maxpay: '',
					promise_mincreditday: '',
					promise_minpayday: '',
					promise_need_pay_after_prev: '',
					promise_pay_only_this_month: '',
					promise_pay_safeday: '',
					promo_days: '',
					promo_month: '',
					promo_next: '',
					pull_dynamic_ip: '',
					pull_dynamic_ip_forceclear: '',
					reserve_plan: '',
					show_www: '',
					tarif_group: '',
					tarif_group_mask: '',
					transfer_allow: '',
					transfer_more_money_end_day: '',
					transfer_only_more_money: '',
					updatetime: '',
					users_balance_warning: '',
					users_limit: '',
					users_limit_warning: '',
					usluga_allow_all: '',
					usluga_range_type: {},
					__self: '',
					__usluga_range_type: '',
				},
			},
			account_id: '',
			account_number: '',
			activate_date: '',
			agent_scheme: '',
			alert_crm: '',
			alert_hdsk: '',
			alert_last_date: '',
			atol_config_id: '',
			attrib_1: '',
			attrib_9: '',
			attrib_24: '',
			attrib_26: '',
			attrib_27: '',
			attrib_30: '',
			attrib_1007: '',
			attrib_1010: '',
			auto_account: '',
			auto_account_interval: '',
			autopay_pay_log_id: '',
			balance: '',
			billing_settings_id: '',
			bonus_score: '',
			category_id: '',
			code1c: '',
			company: '',
			contract_number: '',
			contract_prefix: '',
			create_date: '',
			create_date_system: '',
			currency_id: '',
			days_until: '',
			deleted: '',
			disabled_date: '',
			disabled_date_end: '',
			discount: '',
			email: '',
			enabled: '',
			enough_to_date: '',
			fio: '',
			home_entrance: '',
			home_id: '',
			id: '',
			imported_id: '',
			in_block: '',
			ip_pull_id: '',
			is_folder: '',
			level: '',
			lft: '',
			limit: '',
			limit_warning: '',
			login: '',
			loyalty_id: '',
			main: '',
			master_id: '',
			migration_info: '',
			minimal_pay_sum: '',
			modified: '',
			multi_act: '',
			name: '',
			nds: '',
			need_recalc: '',
			need_refresh_cache: '',
			next_auto_acount: '',
			operator_id: '',
			own_disabled_end: '',
			own_disabled_start: '',
			parent_id: '',
			penalties: '',
			personal_act: '',
			prebilled: '',
			promise_countpermonth: '',
			promise_date_end: '',
			promise_pay: '',
			push_token: '',
			recomend_pay_sum: '',
			recursive_childs_count: '',
			recursive_deleted_childs_count: '',
			rewrite_inherit: '',
			rght: '',
			security_alert: '',
			send_act: '',
			sms: '',
			status: '',
			sum_byte_in_d: '',
			sum_byte_in_h: '',
			sum_byte_in_m: '',
			sync1c: '',
			tarif: '',
			tarif_id: '',
			tarif_next_date: '',
			tarif_next_date_prev: '',
			tarif_next_id: '',
			tarif_notified: '',
			tree_id: '',
			unit: '',
			user: {
				a_home_number: '',
				abonent_id: '',
				abonent_pay: '',
				abonent_pay_cache: '',
				abonent_pay_iftraffic_cache: '',
				abonent_pay_next_date: '',
				abonent_pay_nonegbal_cache: '',
				activate_date: '',
				activate_string: '',
				ad_basedn: '',
				ad_binddn: '',
				ad_domain: '',
				ad_domain_isjoin: '',
				ad_filter: '',
				ad_host: '',
				ad_is: '',
				ad_ldap_group: '',
				ad_pass: '',
				ad_sync: '',
				ad_update: '',
				ad_windows_group: '',
				allow_internet_connect: '',
				allow_mail: '',
				allow_mail_internet: '',
				allow_reconnect: '',
				allow_view_parent_limit: '',
				always_logged: '',
				ask_password_lk: '',
				auth_type_cache: '',
				auth_type_id: '',
				auto_account: '',
				auto_account_interval: '',
				auto_account_lock: '',
				call_limit: '',
				card_activate: '',
				card_admin: '',
				card_id: '',
				card_series_id: '',
				code1c: '',
				comment: '',
				company: '',
				contract: '',
				contract_date_change: '',
				contract_number: '',
				create_date: '',
				credit: '',
				credit_adjust: '',
				deactivate_string: '',
				debit: '',
				def_allow_internet_connect: '',
				def_allow_mail: '',
				def_allow_mail_internet: '',
				def_allow_reconnect: '',
				def_allow_view_parent_limit: '',
				def_auto_account_interval: '',
				def_limit: '',
				def_ostatok: '',
				def_warning: '',
				deleted: '',
				dhcp_mask: '',
				dhcp_route_ip: '',
				disabled_date: '',
				email: '',
				enabled: '',
				end_user: '',
				equipment_id: '',
				ext_id: '',
				fin_admin: '',
				finance_user: '',
				force_maildir: '',
				full_admin: '',
				fw_is_checked: '',
				gen_pwd: '',
				get_info_ban: '',
				gpon_modem_port: '',
				home_id: '',
				host_ip: '',
				host_pull_id: '',
				hw_serial: '',
				id: '',
				identify: '',
				if_ismain: '',
				if_number: '',
				if_role: '',
				if_subnumber: '',
				if_usable: '',
				imported_id: '',
				ip: '',
				ip_renew_lock: '',
				ipv6: '',
				is_allow_search: '',
				is_hidden_info: '',
				is_template: '',
				knl_update: '',
				limit: '',
				limit_ip: '',
				limit_lock: '',
				limit_warning: '',
				logged: '',
				logged_auth_type_id: '',
				login: '',
				login_upper: '',
				mac: '',
				mask: '',
				modified: '',
				myfin_group_id: '',
				nas_id: '',
				nas_ip: '',
				nas_ip_lock: '',
				need_cache_to_session: '',
				need_refresh: '',
				net_size: '',
				next_auto_acount: '',
				opt82: '',
				opt82_param: '',
				ostatok: '',
				over_limit_date: '',
				own_disabled_end: '',
				parid: '',
				phone_id: '',
				plan_next_date: '',
				plan_next_date_prev: '',
				plan_next_id: '',
				promise_countpermonth: '',
				promise_date_end: '',
				promise_pay: '',
				ps_do_block: '',
				psw: '',
				psw_token: '',
				psw_token_date: '',
				pull_id: '',
				read_admin: '',
				redirect_mail: '',
				root_admin: '',
				router_ip: '',
				router_port: '',
				router_vlan: '',
				send_act: '',
				server: '',
				serverid: '',
				service_type_id: '',
				skip_one: '',
				sms: '',
				snat_pull_id: '',
				snatip: '',
				snatip_cache: '',
				stat_last_auth: '',
				stat_last_error: '',
				stat_last_logout: '',
				switch_id: '',
				switch_p_id: '',
				sync1c: '',
				tarif_need_refresh: '',
				tarif_notified: '',
				tariff_id_cache: '',
				tariff_no: '',
				tariff_ver_cache: '',
				tech_admin: '',
				tray_have_msg: '',
				turbospeed_endtime: '',
				turbospeed_id: '',
				unlimited: '',
				users_usluga_id: '',
				usluga_oift_next_date: '',
				usluga_oift_onb_next_date: '',
				utype: '',
				versionn: '',
				___abonent_cache: '',
				_abonent_cache: {
					a_home_number: '',
					abon_pay_for_today: '',
					account: {},
					activate_date: '',
					agent_scheme: '',
					alert_crm: '',
					alert_hdsk: '',
					alert_last_date: '',
					allow_internet: '',
					atol_config: '',
					auto_account: '',
					auto_account_interval: '',
					autopay_pay_log: '',
					billing_settings: '',
					category: {},
					child_folders_count: '',
					childs_count: '',
					code1c: '',
					company: '',
					contract_number: '',
					contract_prefix: '',
					create_date: '',
					create_date_system: '',
					currency: {},
					deleted: '',
					disabled_date: '',
					disabled_date_end: '',
					discount: '',
					do_notify_changes: '',
					email: '',
					enabled: '',
					generated_contract_number: '',
					home: {},
					home_entrance: '',
					id: '',
					imported_id: '',
					ip_pull: '',
					is_folder: '',
					level: '',
					lft: '',
					loyalty: '',
					main: '',
					master: '',
					migration_info: '',
					minimal_pay_sum: '',
					modified: '',
					multi_act: '',
					name: '',
					nds: '',
					need_recalc: '',
					need_refresh_cache: '',
					next_auto_acount: '',
					object_status: {},
					operator: {},
					own_disabled_end: '',
					own_disabled_start: '',
					parent: {},
					penalties: '',
					personal_act: '',
					pk: '',
					post_pay_credit: '',
					prebilled: '',
					promise_countpermonth: '',
					promise_date_end: '',
					promise_pay: '',
					push_token: '',
					real_limit: '',
					recomend_pay_sum: '',
					recomend_pay_sum_post: '',
					recursive_childs_count: '',
					recursive_deleted_childs_count: '',
					rewrite_inherit: '',
					rght: '',
					security_alert: '',
					send_act: '',
					sms: '',
					sync1c: '',
					tarif: {},
					tarif_next: '',
					tarif_next_date: '',
					tarif_next_date_prev: '',
					tarif_notified: '',
					tree_id: '',
					usluga_range_type: {},
					__account: '',
					__category: '',
					__currency: '',
					__home: '',
					__object_status: '',
					__operator: '',
					__parent: '',
					__self: '',
					__tarif: '',
					__usluga_range_type: '',
				},
				_changed_data: [],
				_prefetched_objects_cache: {},
				_state: '',
			},
			usluga_range_type_id: '',
			_account_cache: '',
			_changed_data: '',
			_operator_cache: '',
			_prefetched_objects_cache: '',
			_state: '',
			_tarif_cache: '',
			error: '',
			login_error: '',
			message: '',
		},
		error: null,
	},
	loading: false,
	error: '',
};

export const fetchAbonent = createAsyncThunk('api/fetchAbonent', (action: string) => api.fetchAbonent(action));

const abonentSlice = createSlice({
	name: 'abonent',
	initialState,
	reducers: {},
	extraReducers(builder) {
		builder
			.addCase(fetchAbonent.pending, (state) => {
				state.loading = true;
				state.error = '';
			})
			.addCase(fetchAbonent.fulfilled, (state, action) => {
				state.loading = false;
				state.data = action.payload || {};
				state.error = '';
			})
			.addCase(fetchAbonent.rejected, (state) => {
				state.loading = false;
				state.error = 'Ошибка при загрузке';
			});
	},
});

export default abonentSlice.reducer;
